import React from 'react';
import MainLayout from '../../components/Layout/MainLayout';
import { BtnPrimary } from '../../components/UI/UIComponents';
import { useNavigate } from 'react-router-dom';
import './PageNotFound.css';

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <MainLayout pageTitle="404 — Not Found">
      <div className="notfound">
        <div className="nf-code">404</div>
        <h2 className="nf-title">Page not found</h2>
        <p className="nf-desc">The page you're looking for doesn't exist or has been moved.</p>
        <BtnPrimary onClick={() => navigate('/')}>← Back to Dashboard</BtnPrimary>
      </div>
    </MainLayout>
  );
};

export default PageNotFound;
